








































import { defineComponent } from "@vue/composition-api";
import SendMessageController from "@/components/SendMessageController";
import MessageSendWithAttachmentView from "./components/MessageSendWithAttachmentView.vue";

export default defineComponent({
  name: "MessageSendWithAttachment",
  components: { MessageSendWithAttachmentView, SendMessageController },
  props: {
    recipientIds: { required: true, type: Array as () => string[] },
    threadId: { type: String },
  },
});
